import styled, { css } from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'

export const Image = styled.img`
    max-width: 120px;

    @media ${respondAbove.xl} {
        max-width: 160px;
    }
`

interface LoaderWrapperProps {
    isCentered?: boolean
}

export const LoaderWrapper = styled.div<LoaderWrapperProps>`
    ${({ isCentered }) =>
        isCentered &&
        css`
            position: fixed;
            left: 50%;
            top: 50%;
            margin-left: -13px;
            margin-top: -13px;
        `}
`
